import Vue from 'vue'
import toastr from '../toastr'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import UploadPhoto from '../../component/dccore-form/uploadPhoto.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import moment from 'moment'
import datePicker from '../../component/dccore-form/datePicker.vue'
import TextInput from '../../component/dccore-form/textInput.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import simpleSingleselect from '../../component/singleselect.vue'
import multimedia from '../../component/dccore-form/multimedia.vue'
import timePicker from '../../component/timePicker.vue'
// Import this component

if ($('#purchaseorder_form').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#purchaseorder_form',
    components: {
      RingLoader,
      UploadPhoto,
      Singleselect,
      moment,
      datePicker,
      simpleSingleselect,
      TextInput,
      NumberInput,
      multimedia,
      timePicker
    },
    mixins: [mixins],
    data: {
      loading: 0,
      form: {
        entity: {
          createdDate: moment().format('YYYY-MM-DD HH:mm'),
          items: [],
          status: 'created',
          createdBy: null,
          expectedDeliveryDate: moment().locale('pl').format('YYYY-MM-DD HH:mm'),
          supplyWarehouse: null,
          deliveryTimeFrom: null,
          deliveryTimeTo: null
        },
        options: {
          errors: { items: {} },
          suppliers: [],
          materials: [],
          statuses: [],
          products: [],
          supplyWarehouses: [],
          deliveryAddresses: [],
        }
      },

      summaries: { 1: 0 },
      user: null,
      entityId: null,
      sumPrice: 0,
      sumPriceFinal: 0,
      actualNrItems: 1,
      date: new Date(),
      multimedia: [],
    },
    watch: {
      'form.entity.supplier': function (newValue, oldValue) {
        if (Number(newValue) !== Number(oldValue)) {
          this.getProducts()

          // if there's no old value then it's not a change, it's setting by script on init
          if (oldValue) {
            this.defaultItems()
          }
        }
      }
    },
    mounted: function () {
      if ($('#entity_id').length) {
        this.entityId = $('#entity_id').val()
        this.getPurchaseOrder()
      } else {
        this.defaultItems()
      }

      this.getSupplier()
      this.getMaterials()
      this.getStatuses()
      this.getSupplyWarehouses()
      this.getDeliveryAddresses()
    },
    methods: {
      createPurchaseOrder: function (redirect) {
        $('.button-save').button('loading')
        let url = Routing.generate('api_post_purchase_order')

        Vue.http.post(url, {
          data: this.form.entity,
          multimedia: this.multimedia,

        }).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('purchase_order_grid'))
          } else {
            $('.button-save').button('reset')
            toastr.success(Translator.trans('form.created'))
          }
        }, response => {
          this.handleAjaxError(response, this.form.options)
        })
      },
      updatePurchaseOrder: function (redirect, generatePdf = false) {
        $('.button-save').button('loading')
        let url = Routing.generate('api_patch_purchase_order', { id: this.entityId })

        // clean up temporal field before sending order to backend
        this.form.entity.items.forEach(item => {
          delete item.isEditable;
        });

        this.$http.patch(url, {
          data: this.form.entity,
          multimedia: this.multimedia,
        }).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('purchase_order_grid'))
            return
          }

          if (generatePdf) {
            $(location).attr('href', Routing.generate('purchase_order_generate_pdf', { id: this.entityId }))
          }

          this.getStatuses()

          toastr.success(Translator.trans('form.updated'))
          this.form.options.errors = { items: {} }
          this.getPurchaseOrder()
          $('.button-save').button('reset')
        }, response => {
          this.handleAjaxError(response, this.form.options)
        })
      },
      getPurchaseOrder: function () {
        let url = Routing.generate('api_get_purchase_order', { id: this.entityId,
          context: 'edit' })
        this.loading++
        this.$http.get(url).then(response => {
          this.sumPriceFinal = response.data.sumAmountFinal
          this.form.entity = response.data
          this.form.entity.supplyWarehouse = response.data.supplyWarehouse.id
          this.form.entity.items = this.form.entity.itemsForEdit
          if (response.data.deliveryAddress) {
            this.form.entity.deliveryAddress = response.data.deliveryAddress.id
          }
          this.refreshProducts()
          delete this.form.entity.itemsForEdit

          if (this.form.entity.multimedia) {
            this.multimedia = this.form.entity.multimedia.collection
            delete this.form.entity.multimedia
          }

          this.refreshSumAmount()

          this.form.entity.items.forEach(item => {
            item.isEditable = false;
          });

          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getSupplier: function () {
        this.loading++
        let url = Routing.generate('api_get_suppliers_active', { context: 'dropdown' })

        Vue.http.get(url).then(response => {
          this.form.options.suppliers = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getMaterials: function () {
        this.loading++
        let url = Routing.generate('api_get_materials', { context: 'dropdown' })

        Vue.http.get(url).then(response => {
          this.form.options.materials = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getStatuses: function () {
        this.loading++
        let url = Routing.generate('api_get_purchase_order_statuses', { purchaseOrder: this.entityId })

        Vue.http.get(url).then(response => {
          this.form.options.statuses = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getSupplyWarehouses: function () {
        this.loading++
        let url = Routing.generate('api_get_warehouse_supply_warehouses')

        Vue.http.get(url).then(response => {
          this.form.options.supplyWarehouses = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getDeliveryAddresses() {
        let url = Routing.generate('api_get_tags', { type: 'delivery_address',
          context: 'dropdown' })

        this.loading++
        this.$http.get(url).then(response => {
          this.form.options.deliveryAddresses = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getProducts: function () {
        if (!this.form.entity.supplier) {
          return
        }

        this.loading++

        let url = Routing.generate('api_get_products_buyable_by_supplier', {
          id: this.form.entity.supplier,
          context: 'dropdown'
        })

        this.$http.get(url).then(response => {
          const products = response.data
          this.form.entity.items.forEach((i) => {
            const product = products.find(p => p.id === i.product)
            if (!product) {
              products.push({
                id: i.product,
                name: i.productName,
                materialId: i.productMaterialId,
                inActive: true,
              })
            }
          })

          this.form.options.products = products
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getProduct(object, i) {
        if (this.form.entity.supplier) {
          let url = Routing.generate('api_get_product_with_price', {
            id: object.id,
            supplier: this.form.entity.supplier,
            context: 'edit'
          })

          this.$http.get(url).then(response => {
            this.form.entity.items[i].unit = Translator.trans(`product.entity.units.${response.data.product.unit}`)
            this.form.entity.items[i].weight = response.data.product.weight

            // if it's create, set the price, in other case don't touch it(it can be setted by user)
            if (!this.form.entity.items[i].id) {
              this.form.entity.items[i].priceNetto = response.data.price
            }

            this.form.entity.items[i].orderAmount = Math.round(
              (
                this.form.entity.items[i].amount
                  ? parseFloat(this.form.entity.items[i].amount)
                  : 0
              )
                            * this.form.entity.items[i].weight
                            * 1000
            ) / 1000

            this.refreshSumAmount()
            this.$forceUpdate()
          }, response => {
            this.handleAjaxError(response)
          })
        } else {
          let url = Routing.generate('api_get_product', {
            id: this.form.entity.items[i].product,
            context: 'edit'
          })
          this.$http.get(url).then(response => {
            this.form.entity.items[i].unit = Translator.trans(`product.entity.units.${response.data.unit}`)

            let amount = 0
            if (this.form.entity.items[i].amount) {
              amount = parseFloat(this.form.entity.items[i].amount)
            }
            this.form.entity.items[i].orderAmount = amount * this.form.entity.items[i].weight
            this.refreshSumAmount()

            this.$forceUpdate()
          }, response => {
            this.handleAjaxError(response)
          })
        }
      },
      refreshProducts() {
        let that = this
        Object.keys(this.form.entity.items).forEach((index) => {
          let product = {
            id: that.form.entity.items[index].product
          }
          that.getProduct(product, index)
        })
      },
      addItem() {
        // isEditable is a temporal field, which is cleaned up before saving purchase order to the backend
        // it's used for blocking changing product while editing order
        this.form.entity.items.push({isEditable: true});
        this.$forceUpdate()
      },
      removeItem(i) {
        this.form.entity.items[i].deletedAt = (new Date()).toISOString()
        this.refresh()
      },
      restoreItem(i) {
        this.form.entity.items[i].deletedAt = null
        this.refresh()
      },
      clearItems() {
        this.form.entity.items = []
        this.$forceUpdate()
      },
      defaultItems() {
        this.clearItems()
        this.addItem()
      },
      calculateValue(i) {
        let value = this.form.entity.items[i].amount * this.form.entity.items[i].priceNetto
        this.form.entity.items[i].value = isNaN(value) ? 0 : parseFloat(value).toFixed(2)

        this.form.entity.items[i].orderAmount = Math.round(
          this.form.entity.items[i].amount
                    * this.form.entity.items[i].weight
                    * 1000
        ) / 1000
        this.$forceUpdate()
      },
      emptyToZero() {
        Object.entries(this.form.entity.items).map(obj => {
          let i = obj[0]

          let value = this.form.entity.items[i].amount
          if (!value) {
            this.form.entity.items[i].amount = 0
          }
        })
      },
      refreshSumAmount() {
        this.loading++

        let sums = Object.entries(this.form.entity.items).map(obj => {
          let key = obj[0]
          let item = obj[1]

          this.calculateValue(key)
          let val = item.amount * item.priceNetto
          return isNaN(val) ? 0 : val
        })

        this.sumPrice = parseFloat(sums.reduce((a, b) => a + b, 0)).toFixed(2)
        this.loading--
      },
      translateStatus(name) {
        return Translator.trans(`purchase_order.entity.statuses.${name}`)
      },
      setSupplyWarehouseDeliveryAddress(e) {
        if (e.deliveryAddressId) {
          this.form.entity.deliveryAddressId = e.deliveryAddressId
        }
      }
    },
  })
}
